import { MdNotifications } from 'react-icons/md';

export function NotificationBell({ unreadCount, onClick }) {
    return (
        <button
            onClick={onClick}
            className="relative p-2 text-gray-500 hover:text-custom_blue transition-colors"
            aria-label="Notificações"
        >
            <MdNotifications size={26} />
            {unreadCount > 0 && (
                <span className="absolute top-0.5 right-0.5 min-w-[18px] h-[18px] bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center px-1">
                    {unreadCount > 99 ? '99+' : unreadCount}
                </span>
            )}
        </button>
    );
}
